import { Link } from 'react-router';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 text-center">
      <div className="text-6xl font-extrabold text-orange/40 mb-4">404</div>
      <h1 className="text-xl font-extrabold mb-2">Page Not Found</h1>
      <p className="text-sm text-ink-3 mb-6">
        The page you&apos;re looking for doesn&apos;t exist.
      </p>
      <Link to="/dashboard">
        <Button>Go to Dashboard</Button>
      </Link>
    </div>
  );
}
